import Menu from "../../../components/menu/menu.jsx";
import Busca from "../../../components/busca/busca.jsx";
import MyDataTable from "../../../components/mydatatable/mydatatable.jsx";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ClienteCad from "../clientescad/clientescad.jsx";
import { useCallback, useEffect, useRef, useState } from "react";
import writeXlsxFile from "write-excel-file/browser";
import api from "../../../services/api.js";
import Filtrossindicalizados from "../../../components/filtrossindicalizados/filtrossindicalizados.jsx";
import {
  fetchAllPaginatedRows,
  filterInactiveRowsByDate,
  loadAllClientesSocios,
} from "../../../services/associadosImport.js";
import "./cliente.css";
import ClientesPDF from "../../../components/relatorios/clientes/lista/rel_listacliente.jsx";

const initialState = {
  unidade: "",
  curso: "",
  situacao: "",
  aniversariantes: "",
  inifiliacao: "",
  fimfiliacao: "",
  tipocontribuicao: "",
  cpf: "",
  departamento: "",
};

const formatarData = (data) => {
  if (!data) {
    return "";
  }

  const parsed = new Date(data);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }

  const dia = String(parsed.getDate()).padStart(2, "0");
  const mes = String(parsed.getMonth() + 1).padStart(2, "0");
  const ano = parsed.getFullYear();
  return `${dia}/${mes}/${ano}`;
};

const formatTelefone = (telefone) => {
  if (!telefone) {
    return "";
  }

  return telefone
    .replace(/\D/g, "")
    .replace(/(\d{1})(\d{4})(\d{4})/, "$1 $2-$3");
};

const formatDdd = (ddd) => {
  if (ddd && ddd.length >= 2) {
    return ddd.substring(ddd.length - 2);
  }
  return ddd;
};

const formatCNPJ = (cnpj = "") => {
  if (!cnpj) {
    return "";
  }

  if (cnpj.length <= 11) {
    return cnpj
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  return cnpj
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
};

const getCurrentDateInputValue = () => {
  const today = new Date();
  const timezoneOffset = today.getTimezoneOffset() * 60000;
  return new Date(today.getTime() - timezoneOffset).toISOString().slice(0, 10);
};

const buildFilterParams = (status, buscaTexto, filtros, page, pageSize) => ({
  busca: buscaTexto || undefined,
  status: status || "Todos",
  unidade: filtros.unidade || undefined,
  curso: filtros.curso || undefined,
  situacao: filtros.situacao || undefined,
  aniversariantes: filtros.aniversariantes || undefined,
  inifiliacao: filtros.inifiliacao || undefined,
  fimfiliacao: filtros.fimfiliacao || undefined,
  tipocontribuicao: filtros.tipocontribuicao || undefined,
  cpf: filtros.cpf || undefined,
  departamento: filtros.departamento || undefined,
  page,
  pageSize,
});

const DEFAULT_PAGE_SIZE = 10;
const PAGE_SIZE_OPTIONS = [10, 30, 50, 100];

const sliceRowsForPage = (rows, page, pageSize) => {
  const start = (page - 1) * pageSize;
  return rows.slice(start, start + pageSize);
};

function Clientes() {
  const todayDate = getCurrentDateInputValue();
  const [isMenuVisible, setIsMenuVisible] = useState(true);
  const [status, setStatus] = useState("Todos");
  const [qtd_reg_pagina, setQtdRegPagina] = useState(DEFAULT_PAGE_SIZE);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [dados, setDados] = useState([]);
  const [total_registros, setTotalRegistros] = useState(0);
  const [buscaTexto, setBuscaTexto] = useState("");
  const [tipoemp, setTipoemp] = useState();
  const [titulo, setTitulo] = useState();
  const [filtros, setFiltros] = useState(initialState);
  const [filtroDesativados, setFiltroDesativados] = useState({
    inicio: todayDate,
    fim: todayDate,
  });
  const [buscaResetSignal, setBuscaResetSignal] = useState(0);
  const [exportingPdf, setExportingPdf] = useState(false);
  const forcedStatusRef = useRef(null);

  const isSindicato =
    tipoemp && typeof tipoemp === "string" && tipoemp.slice(0, 2) === "10";
  const hasInactiveDateFilter =
    status === "Inativos" &&
    (Boolean(filtroDesativados.inicio) || Boolean(filtroDesativados.fim));

  const handleDataChange = (updatedfiltros) => {
    setPaginaAtual(1);
    setFiltros((current) => ({
      ...current,
      ...updatedfiltros,
    }));
  };

  const commonColumns = [
    {
      name: "Codigo",
      selector: (row) => row.cdcli,
      sortable: true,
      width: "90px",
    },
    {
      name: "Descricao",
      selector: (row) => row.decli,
      sortable: true,
      compact: true,
      width: "200px",
    },
    {
      name: "Telefone",
      selector: (row) => (
        <p className="mb-1">
          ({formatDdd(row.dddcli)}) {formatTelefone(row.fonecli)}
        </p>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Cidade",
      selector: (row) => row.cidcli,
      sortable: true,
      width: "120px",
    },
    {
      name: "Bairro",
      selector: (row) => row.baicli,
      sortable: true,
      width: "170px",
      compact: true,
    },
    {
      cell: (row) => (
        <div className="right-aligned-cell">
          <button
            onClick={() => WhatsApp(row.dddcli + row.fonecli)}
            className={row.fonecli ? "btn btn-success" : "btn btn-success disabled"}
          >
            <i className="bi bi-whatsapp"></i>
          </button>
          <button onClick={() => Editar(row.cdcli)} className="btn btn-primary ms-1">
            <i className="bi bi-pencil-square"></i>
          </button>
          <button onClick={() => Excluir(row.cdcli)} className="btn btn-danger ms-1">
            <i className="bi bi-trash3-fill"></i>
          </button>
        </div>
      ),
      width: "200px",
      right: true,
    },
  ];

  const commonColumns2 = [
    {
      name: "CODIGO",
      selector: (row) => row.cdcli,
      sortable: true,
      width: "9%",
      style: { fontSize: "11px" },
    },
    {
      name: "NOME",
      selector: (row) => row.decli,
      sortable: true,
      compact: true,
      width: "17%",
      style: { fontSize: "11px" },
    },
    {
      name: "CPF",
      selector: (row) => formatCNPJ(row.cnpj_cpfcli || ""),
      sortable: true,
      compact: true,
      width: "8%",
      style: { fontSize: "11px" },
    },
    {
      name: "SIAP",
      selector: (row) => row.matricula,
      sortable: true,
      compact: true,
      width: "7%",
      style: { fontSize: "11px", margin: "-1 1px" },
    },
    {
      name: "TELEFONE",
      selector: (row) => (
        <p className="mb-1">
          ({formatDdd(row.dddcli)}) {formatTelefone(row.fonecli)}
        </p>
      ),
      sortable: true,
      width: "11%",
      style: { fontSize: "11px" },
    },
    {
      name: "UNIDADE",
      selector: (row) => row.unidade,
      sortable: true,
      compact: true,
      width: "7%",
      style: { fontSize: "11px" },
    },
    {
      name: "CURSO",
      selector: (row) => row.curso,
      sortable: true,
      compact: true,
      width: "15%",
      style: { fontSize: "11px" },
    },
    filtros.aniversariantes !== ""
      ? {
          name: "NASCIMENTO",
          selector: (row) => formatarData(row.nasctocli),
          sortable: true,
          compact: true,
          width: "10%",
          style: { fontSize: "11px", textAlign: "center" },
        }
      : {
          name: "SITUACAO",
          selector: (row) => (row.situacao || "").toUpperCase(),
          sortable: true,
          compact: true,
          width: "10%",
          style: { fontSize: "11px", textAlign: "center" },
        },
    {
      name: "Filiado",
      selector: (row) => (row.ativocli || "").toUpperCase(),
      sortable: true,
      compact: true,
      width: "5%",
      style: { fontSize: "11px" },
    },
    {
      cell: (row) => (
        <div className="right-aligned-cell">
          <button
            onClick={() => WhatsApp(row.dddcli + row.fonecli)}
            className={row.fonecli ? "btn btn-success" : "btn btn-success disabled"}
          >
            <i className="bi bi-whatsapp"></i>
          </button>
          <button onClick={() => Editar(row.cdcli)} className="btn btn-primary ms-1">
            <i className="bi bi-pencil-square"></i>
          </button>
          <button onClick={() => Excluir(row.cdcli)} className="btn btn-danger ms-1">
            <i className="bi bi-trash3-fill"></i>
          </button>
        </div>
      ),
      width: "12%",
      right: true,
    },
  ];

  const columns = isSindicato ? commonColumns2 : commonColumns;

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const paginationOptions = {
    rowsPerPageText: "Registros por pagina",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  function WhatsApp(fone) {
    if (fone) {
      const url = `https://web.whatsapp.com/send?phone=55${fone}`;
      window.open(url, "_blank", "noreferrer");
    }
  }

  const iniciarRequisicao = useCallback(
    async (
      nextPage = paginaAtual,
      nextPageSize = qtd_reg_pagina,
      nextStatus = status,
      nextBusca = buscaTexto,
      nextFiltros = filtros,
    ) => {
      try {
        if (hasInactiveDateFilter) {
          const { rows } = await loadAllClientesSocios();
          const filteredRows = filterInactiveRowsByDate(rows, {
            buscaTexto: nextBusca,
            filtros: nextFiltros,
            dataInicial: filtroDesativados.inicio,
            dataFinal: filtroDesativados.fim,
          });

          setPaginaAtual(nextPage);
          setTotalRegistros(filteredRows.length);
          setDados(sliceRowsForPage(filteredRows, nextPage, nextPageSize));
          return;
        }

        const response = await api.get("/admin/clientes/filtros", {
          params: buildFilterParams(
            nextStatus,
            nextBusca,
            nextFiltros,
            nextPage,
            nextPageSize,
          ),
        });

        setPaginaAtual(nextPage);
        setTotalRegistros(response.data?.count || 0);
        setDados(response.data?.rows || []);
      } catch (error) {
        setTotalRegistros(0);
        setDados([]);
        alert("Erro ao carregar clientes...");
      }
    },
    [
      buscaTexto,
      filtroDesativados.fim,
      filtroDesativados.inicio,
      filtros,
      hasInactiveDateFilter,
      paginaAtual,
      qtd_reg_pagina,
      status,
    ],
  );

  const carregarDadosBase = useCallback(async () => {
    await iniciarRequisicao(1, qtd_reg_pagina, status, buscaTexto, filtros);
  }, [buscaTexto, filtros, iniciarRequisicao, qtd_reg_pagina, status]);

  function Excluir(id) {
    confirmAlert({
      title: "Exclusao",
      message: "Confirma a exclusao do registro?",
      buttons: [
        {
          label: "Sim",
          onClick: async () => {
            try {
              await api.delete(`/t_cli/${id}`);
              await carregarDadosBase();
              alert(`Registro: ${id} excluido com sucesso!`);
            } catch (err) {
              alert("Erro ao excluir cliente.");
            }
          },
        },
        {
          label: "Nao",
          onClick: () => {},
        },
      ],
    });
  }

  function Editar(id) {
    const event = new CustomEvent("openSidebar", {
      detail: {
        operacao: "edit",
        codcli: id,
      },
    });

    window.dispatchEvent(event);
  }

  function Incluir() {
    const event = new CustomEvent("openSidebar", {
      detail: {
        operacao: "Incluir",
      },
    });

    window.dispatchEvent(event);
  }

  function ChangeStatus(e) {
    forcedStatusRef.current = null;
    setPaginaAtual(1);
    setStatus(e.target.value);
  }

  function ChangePerRows(newQtd) {
    const nextQtd = Number(newQtd);
    if (!Number.isFinite(nextQtd) || nextQtd <= 0 || nextQtd === qtd_reg_pagina) {
      return;
    }

    setQtdRegPagina(nextQtd);
    setPaginaAtual(1);
  }

  function ChangePage(page) {
    if (page === paginaAtual) {
      return;
    }
    setPaginaAtual(page);
  }

  function handleBusca(texto) {
    setPaginaAtual(1);
    setBuscaTexto(texto);
  }

  function handleFiltroDesativadosChange(field, value) {
    if (!hasInactiveDateFilter && forcedStatusRef.current === null) {
      forcedStatusRef.current = status;
    }

    setPaginaAtual(1);
    setStatus("Inativos");
    setFiltroDesativados((current) => ({
      ...current,
      [field]: value,
    }));
  }

  function limparConsulta() {
    forcedStatusRef.current = null;
    setPaginaAtual(1);
    setStatus("Todos");
    setBuscaTexto("");
    setFiltros(initialState);
    setFiltroDesativados({
      inicio: todayDate,
      fim: todayDate,
    });
    setBuscaResetSignal((current) => current + 1);
  }

  useEffect(() => {
    iniciarRequisicao();
  }, [iniciarRequisicao]);

  useEffect(() => {
    setTipoemp(localStorage.getItem("tipoemp"));
  }, []);

  useEffect(() => {
    if (tipoemp && typeof tipoemp === "string") {
      setTitulo(tipoemp.slice(0, 2) === "10" ? "Sindicalizados" : "Clientes");
    }
  }, [tipoemp]);

  useEffect(() => {
    const refreshHandler = () => {
      iniciarRequisicao(1, qtd_reg_pagina, status, buscaTexto, filtros);
    };

    window.addEventListener("clientesAtualizados", refreshHandler);
    return () => window.removeEventListener("clientesAtualizados", refreshHandler);
  }, [buscaTexto, filtros, iniciarRequisicao, qtd_reg_pagina, status]);

  const exportToExcel = async () => {
    const columnsToExport = dados.map((item) => ({
      Codigo: item.cdcli,
      Nome: item.decli,
      DDD: item.dddcli,
      Fone: item.fonecli,
      ST: item.ativocli === "S" ? "ATIVO" : "INATIVO",
      Admissao: formatarData(item.dtfilicao),
      Situacao: item.situacao || "",
      Nascimento: formatarData(item.nasctocli),
      Curso: item.curso,
    }));

    const sheetData = [
      [
        { value: "Codigo", fontWeight: "bold" },
        { value: "Nome", fontWeight: "bold" },
        { value: "DDD", fontWeight: "bold" },
        { value: "Fone", fontWeight: "bold" },
        { value: "ST", fontWeight: "bold" },
        { value: "Admissao", fontWeight: "bold" },
        { value: "Situacao", fontWeight: "bold" },
        { value: "Nascimento", fontWeight: "bold" },
        { value: "Curso", fontWeight: "bold" },
      ],
      ...columnsToExport.map((row) => [
        row.Codigo,
        row.Nome,
        row.DDD,
        row.Fone,
        row.ST,
        row.Admissao,
        row.Situacao,
        row.Nascimento,
        row.Curso,
      ]),
    ];

    await writeXlsxFile(sheetData, {
      columns: [
        { width: 12 },
        { width: 35 },
        { width: 10 },
        { width: 18 },
        { width: 12 },
        { width: 14 },
        { width: 18 },
        { width: 14 },
        { width: 28 },
      ],
      sheet: "Clientes",
    }).toFile("clientes.xlsx");
  };

  const loadClientesForPdf = useCallback(async () => {
    if (hasInactiveDateFilter) {
      const { rows } = await loadAllClientesSocios();
      return filterInactiveRowsByDate(rows, {
        buscaTexto,
        filtros,
        dataInicial: filtroDesativados.inicio,
        dataFinal: filtroDesativados.fim,
      });
    }

    return fetchAllPaginatedRows(
      "/admin/clientes/filtros",
      buildFilterParams(status, buscaTexto, filtros),
    );
  }, [
    buscaTexto,
    filtroDesativados.fim,
    filtroDesativados.inicio,
    filtros,
    hasInactiveDateFilter,
    status,
  ]);

  const exportToPdf = useCallback(async () => {
    setExportingPdf(true);

    try {
      const clientes = await loadClientesForPdf();
      ClientesPDF(clientes, filtros);
    } catch (error) {
      alert("Erro ao gerar PDF.");
    } finally {
      setExportingPdf(false);
    }
  }, [filtros, loadClientesForPdf]);

  return (
    <div className={isMenuVisible ? "app-container" : "app-container-local"}>
      {isMenuVisible && (
        <div className="menu-visible col-auto col-md-3 col-xl-2 px-sm-2 px-0">
          <Menu page="empresas" />
        </div>
      )}

      <div className="row flex-nowrap">
        <ClienteCad />
        <div className="container-fluid">
          <div className="row flex-nowrap">
            <div className={`col py-3 me-4 ${isMenuVisible ? "" : "expand-content"}`}>
              <div className="mb-5">
                <Busca
                  texto="Digite o nome do cliente"
                  onSearch={handleBusca}
                  onToggleMenu={toggleMenu}
                  value={buscaTexto}
                  resetSignal={buscaResetSignal}
                />
              </div>

                <div className="bg-white p-4 rounded-4 border">
                  <div className="d-flex justify-content-between mb-3">
                    <div className="d-inline-flex">
                      <h2>{titulo}</h2>

                      <div className="form-control ms-4">
                        <select name="status" id="status" value={status} onChange={ChangeStatus}>
                          <option value="Todos">Todos os registros</option>
                          <option value="Ativos">Apenas ativos</option>
                          <option value="Inativos">Apenas desativados</option>
                        </select>
                      </div>
                    </div>

                  <button onClick={Incluir} className="btn btn-primary ms-4">
                    <i className="bi bi-plus-lg me-2"></i>Novo
                  </button>
                </div>

                  <div className="row g-3 mb-3">
                  <div className="col-xl-3 col-md-6">
                    <label className="form-label">Desativados a partir de</label>
                    <input
                      type="date"
                      className="form-control"
                      value={filtroDesativados.inicio}
                      onChange={(event) =>
                        handleFiltroDesativadosChange("inicio", event.target.value)
                      }
                    />
                  </div>
                  <div className="col-xl-3 col-md-6">
                    <label className="form-label">Desativados ate</label>
                    <input
                      type="date"
                      className="form-control"
                      value={filtroDesativados.fim}
                      onChange={(event) =>
                        handleFiltroDesativadosChange("fim", event.target.value)
                      }
                    />
                  </div>
                  <div className="col-xl-6 col-md-12 d-flex align-items-end">
                    {hasInactiveDateFilter ? (
                      <small className="text-secondary">
                        Consulta local de clientes inativos por data de alteracao.
                      </small>
                    ) : null}
                  </div>
                </div>

                <div>
                  <Filtrossindicalizados
                    filtros={filtros}
                    onDataChange={handleDataChange}
                    iniciarRequisicao={carregarDadosBase}
                    initialState={initialState}
                    qtd_reg_pagina={qtd_reg_pagina}
                    onClearFilters={limparConsulta}
                  />
                  <br />
                </div>

                <div className="container-tabela">
                  <MyDataTable
                    columns={columns}
                    data={dados}
                    pagination={true}
                    paginationPerPage={qtd_reg_pagina}
                    paginationRowsPerPageOptions={PAGE_SIZE_OPTIONS}
                    paginationComponentOptions={paginationOptions}
                    noDataComponent={<p className="no-data-found">Nenhum registro encontrado</p>}
                    paginationServer={true}
                    paginationTotalRows={total_registros}
                    onChangeRowsPerPage={ChangePerRows}
                    onChangePage={ChangePage}
                    responsive={true}
                  />
                </div>

                <button onClick={exportToExcel} className="btn btn-success btn-cli">
                  <i className="bi bi-file-excel me-2"></i>Gerar Excel
                </button>
                <button
                  onClick={exportToPdf}
                  className="btn btn-danger btn-cli"
                  disabled={exportingPdf}
                >
                  <i className="fa-regular fa-file-pdf me-2"></i>
                  {exportingPdf ? "Gerando PDF..." : "Gerar PDF"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Clientes;
